/**
 * Re-export of the shared StatsSection component for the storefront renderer.
 * The base component (render + fields + defaults) lives in
 * `@launchstore/shared-puck`. The renderer uses it as-is.
 *
 * See launchstore-shared/src/puck/components/homepage/StatsSection/ for source.
 */
import { StatsSection as SharedStatsSection } from '@launchstore/shared-puck';

export const StatsSection: any = SharedStatsSection;
export type { StatsSectionProps, StatsItem } from '@launchstore/shared-puck';
export default StatsSection;
